import { render, staticRenderFns } from "./PointMap.vue?vue&type=template&id=5d421bba&"
import script from "./PointMap.vue?vue&type=script&lang=ts&"
export * from "./PointMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports